import React, { Component } from 'react';

import * as Constants from '../../../constants/constants'
import { Card, Row, Col, Collapse } from 'react-bootstrap'
import i18n from "../../../i18n";

const marginRemove = {
	marginLeft: "0px",
	marginRight: "0px"
}

const marginRemoveWithBC = {
	marginLeft: "0px",
	marginRight: "0px",
	color: "#fff",
	fontWeight: "bold",
	backgroundColor: Constants.MAIN_COLOR3
}

const titleStyle = {
	backgroundColor: Constants.MAIN_COLOR2,
	color: "#fff",
	fontWeight: "bold",
	marginLeft: "0px",
	marginRight: "0px"
}

const padding = {
	padding: "15px",
	wordWrap: "break-word"
}

const paddingConclusion = {
	padding: "15px",
	wordWrap: "break-word",
	color: "#000",
	backgroundColor: Constants.WHITE
}

const leftClass = "col-lg-10 col-sm-9 col-8 border";
const rightClass = "col-lg-2 col-sm-3 col-4 border";
const sIdClass = "col-lg-1 col-sm-1 col-2 d-flex justify-content-center align-self-center"

export default class Signature extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	render() {
		return (
			<React.Fragment>
				<Row tabIndex="0" role="button" style={titleStyle} className="border-top" onClick={() => this.setState({ open: !this.state.open })} onKeyUp={this.props.handleKeyUp}>
					<Col style={padding} className="col-lg-12 col-sm-12 col-12">
						<Row style={marginRemove}>
							<Col className="col-lg-11 col-sm-11 col-10">
								<Row>
									<Col style={{ "paddingLeft": "5px" }} className="col-3">
										{i18n.t("docInfo:signature_seal_id")}
									</Col>
									<Col className="col-9">
										{this.props.index + 1}. {this.props.data.id}
									</Col>
								</Row>
							</Col>
							<Col className={sIdClass} style={{ "paddingRight": "0px" }}>
								{this.state.open ?
									<i className="material-icons align-middle" aria-hidden="true">expand_less</i>
									:
									<i className="material-icons align-middle" aria-hidden="true">expand_more</i>
								}
							</Col>
						</Row>
					</Col>
				</Row>
				<Collapse in={this.state.open}>
					<div>
						{this.props.data.validationProcessBasicSignatures.constraint.length > 0 ?
							<React.Fragment>
								<Card.Header style={marginRemoveWithBC} className="border">
									{i18n.t("detailed:validation_basic_signature")}
								</Card.Header>
								<div>
									{this.props.data.validationProcessBasicSignatures.constraint.map((constraint, i) => {
										return <div key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
													padding: "15px",
													wordWrap: "break-word",
													backgroundColor: constraintColor(constraint.status)
												}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
											</Row>
										</div>
									})}
									<Row style={marginRemoveWithBC}>
										<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:conclusion")}</Col><Col style={{
											padding: "15px",
											wordWrap: "break-word",
											color: "#fff",
											backgroundColor: indicationColor(this.props.data.validationProcessBasicSignatures.conclusion.indication)
										}} className={rightClass}>{i18n.t("detailed:" + this.props.data.validationProcessBasicSignatures.conclusion.indication)}</Col>
									</Row>
								</div >
							</React.Fragment>
							:
							null
						}
						{this.props.data.validationProcessTimestamps.length > 0 ?
							<React.Fragment>
								<Card.Header style={marginRemoveWithBC} className="border">
									{i18n.t("detailed:validation_timestamps")}
								</Card.Header>
								<div>
									{this.props.data.validationProcessTimestamps.map((validationProcessTimestamps, i) => {
										return <div key={i}>
											<Card.Header style={{
												marginLeft: "0px",
												marginRight: "0px",
												color: "#fff",
												fontWeight: "bold",
												backgroundColor: Constants.MAIN_COLOR3,
												wordWrap: "break-word"
											}} className="border">
												{i18n.t("detailed:" + validationProcessTimestamps.type)} ID={validationProcessTimestamps.id}
											</Card.Header>
											{validationProcessTimestamps.constraint.map((constraint, i) => {
												return <div key={i}>
													<Row style={marginRemove}>
														<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
															padding: "15px",
															wordWrap: "break-word",
															backgroundColor: constraintColor(constraint.status)
														}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
													</Row>
												</div>
											})}
											<Row style={marginRemoveWithBC}>
												<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:conclusion")}</Col><Col style={{
													padding: "15px",
													wordWrap: "break-word",
													color: "#fff",
													backgroundColor: indicationColor(validationProcessTimestamps.conclusion.indication)
												}} className={rightClass}>{i18n.t("detailed:" + validationProcessTimestamps.conclusion.indication)}</Col>
											</Row>
										</div>
									})}
								</div >
							</React.Fragment>
							:
							null
						}
						{this.props.data.validationProcessLongTermData.constraint.length > 0 ?
							<React.Fragment>
								<Card.Header style={marginRemoveWithBC} className="border">
									{i18n.t("detailed:validation_long_term")}
								</Card.Header>
								<div>
									{this.props.data.validationProcessLongTermData.constraint.map((constraint, i) => {
										return <div key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
													padding: "15px",
													wordWrap: "break-word",
													backgroundColor: constraintColor(constraint.status)
												}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
											</Row>
										</div>
									})}
									<Row style={marginRemoveWithBC}>
										<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:conclusion")}</Col><Col style={{
											padding: "15px",
											wordWrap: "break-word",
											color: "#fff",
											backgroundColor: indicationColor(this.props.data.validationProcessLongTermData.conclusion.indication)
										}} className={rightClass}>{i18n.t("detailed:" + this.props.data.validationProcessLongTermData.conclusion.indication)}</Col>
									</Row>
								</div >

							</React.Fragment>
							:
							null
						}
						{this.props.data.validationProcessArchivalData.constraint.length > 0 ?
							<React.Fragment>
								<Card.Header style={marginRemoveWithBC} className="border">
									{i18n.t("detailed:validation_archival")}
								</Card.Header>
								<div>
									{this.props.data.validationProcessArchivalData.constraint.map((constraint, i) => {
										return <div key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
													padding: "15px",
													wordWrap: "break-word",
													backgroundColor: constraintColor(constraint.status)
												}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
											</Row>
										</div>
									})}
									<Row style={marginRemoveWithBC}>
										<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:conclusion")}</Col><Col style={{
											padding: "15px",
											wordWrap: "break-word",
											color: "#fff",
											backgroundColor: indicationColor(this.props.data.validationProcessArchivalData.conclusion.indication)
										}} className={rightClass}>{i18n.t("detailed:" + this.props.data.validationProcessArchivalData.conclusion.indication)}</Col>
									</Row>
								</div >
							</React.Fragment>
							:
							null
						}
						{this.props.data.validationSignatureQualification.constraint.length > 0 ?
							<React.Fragment>
								<Card.Header style={marginRemoveWithBC} className="border">
									{i18n.t("detailed:qualification_signature")} {i18n.t("detailed:" + this.props.data.validationSignatureQualification.signatureQualification)}
								</Card.Header>
								<div>
									{this.props.data.validationSignatureQualification.constraint.map((constraint, i) => {
										return <div key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
													padding: "15px",
													wordWrap: "break-word",
													backgroundColor: constraintColor(constraint.status)
												}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
											</Row>
											{i < this.props.data.validationSignatureQualification.constraint.length - 1 ?
												<>

												</>
												: null
											}
										</div>
									})}
									<Row style={marginRemoveWithBC}>
										<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:conclusion")}</Col><Col style={{
											padding: "15px",
											wordWrap: "break-word",
											color: "#fff",
											backgroundColor: indicationColor(this.props.data.validationSignatureQualification.conclusion.indication)
										}} className={rightClass}>{i18n.t("detailed:" + this.props.data.validationSignatureQualification.conclusion.indication)}</Col>
									</Row>

									{this.props.data.validationSignatureQualification.validationCertificateQualification.map((validationCertificateQualification, i) => {
										return <div key={i}>
											<Card.Header style={marginRemoveWithBC} className="border">
												{i18n.t("detailed:" + validationCertificateQualification.certificateQualification)} @
												{i18n.t("detailed:" + validationCertificateQualification.validationTime)}
											</Card.Header>

											{validationCertificateQualification.constraint.map((constraint, i) => {
												return <div key={i}>
													<Row style={marginRemove}>
														<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
															padding: "15px",
															wordWrap: "break-word",
															backgroundColor: constraintColor(constraint.status)
														}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
													</Row>
													{i < validationCertificateQualification.constraint.length - 1 ?
														<>

														</>
														: null
													}
												</div>
											})}
											<Row style={marginRemoveWithBC}>
												<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:conclusion")}</Col><Col style={{
													padding: "15px",
													wordWrap: "break-word",
													color: "#fff",
													backgroundColor: indicationColor(validationCertificateQualification.conclusion.indication)
												}} className={rightClass}>{i18n.t("detailed:" + validationCertificateQualification.conclusion.indication)}</Col>
											</Row>

										</div>
									})}
								</div >
							</React.Fragment>
							:
							null
						}
					</div >
				</Collapse >
			</React.Fragment>
		);
	}
}

function indicationColor(tIndication) {
	if (tIndication == "TOTAL_PASSED" || tIndication == "PASSED") {
		return Constants.GREEN;
	} else if (tIndication == "INDETERMINATE") {
		return Constants.ORANGE;
	} else if (tIndication == "TOTAL_FAILED" || tIndication == "FAILED") {
		return Constants.RED;
	}
	return Constants.WHITE;
}

function constraintColor(tConstraint) {
	if (tConstraint == "OK") {
		return Constants.OK;
	} else if (tConstraint == "WARNING" || tConstraint == "IGNORED" || tConstraint == "INFORMATION") {
		return Constants.WARNING;
	} else if (tConstraint == "NOT_OK") {
		return Constants.NOT_OK;
	}
	return Constants.WHITE;
}